.root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.dropzone {
  align-items: center;
  background-color: var(--color-muted, #f4f4f5);
  border: 2px dashed var(--color-border, #d4d4d8);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 32px 24px;
  transition:
    background-color 120ms ease,
    border-color 120ms ease;
}

.dropzone:hover {
  background-color: var(--color-accent, #e4e4e7);
  border-color: var(--color-ring, #71717a);
}

.dropzone-icon {
  color: var(--color-muted-foreground, #71717a);
}

.dropzone-prompt {
  color: var(--color-foreground, #18181b);
  font-size: 14px;
  font-weight: 500;
}

.dropzone-hint {
  color: var(--color-muted-foreground, #71717a);
  font-size: 12px;
  text-align: center;
}

.selecting {
  align-items: center;
  background-color: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
}

.selecting-meta {
  color: var(--color-muted-foreground, #71717a);
  font-size: 12px;
}

.compression-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.busy {
  align-items: center;
  background-color: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 32px 24px;
}

.progress-bar {
  background-color: var(--color-muted, #f4f4f5);
  border-radius: 999px;
  height: 6px;
  max-width: 320px;
  overflow: hidden;
  width: 100%;
}

.progress-fill {
  background-color: var(--color-primary, #18181b);
  border-radius: 999px;
  height: 100%;
  transition: width 200ms ease;
}

.progress-fill-success {
  background-color: var(--color-success-alt, #10b981);
}

.stats {
  background-color: var(--color-muted, #f4f4f5);
  border-radius: 6px;
  color: var(--color-muted-foreground, #71717a);
  font-size: 12px;
  padding: 8px 12px;
  text-align: center;
}

.stats-saved {
  color: var(--color-success-alt, #10b981);
  font-weight: 500;
}

.complete {
  align-items: center;
  background-color: var(--color-muted, #f4f4f5);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 8px;
  color: var(--color-foreground, #18181b);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
}

.error {
  align-items: center;
  background-color: var(--color-destructive, #fef2f2);
  border: 1px solid var(--color-destructive-hover, #fecaca);
  border-radius: 8px;
  color: var(--color-destructive-foreground, #991b1b);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
}

.btn {
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 6px;
  color: var(--color-foreground, #18181b);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 14px;
}

.btn:hover:not(:disabled) {
  background-color: var(--color-muted, #f4f4f5);
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.btn-ghost {
  background: transparent;
  border-color: transparent;
}

.btn-sm {
  font-size: 13px;
  padding: 4px 10px;
}

.text {
  color: var(--color-foreground, #18181b);
  font-size: 14px;
}

.text-medium {
  font-weight: 500;
}

@keyframes uploadthing-spin {
  to {
    transform: rotate(360deg);
  }
}

.spinner {
  animation: uploadthing-spin 0.8s linear infinite;
  border: 2px solid var(--color-border, #d4d4d8);
  border-radius: 50%;
  border-top-color: var(--color-primary, #18181b);
  height: 20px;
  width: 20px;
}
